window.appRuntimeEnv = {}

async function loadConfig() {
    try {
        const config = await fetch('/config.json')
        const configJson = await config.json()
        window.appRuntimeEnv = {
            ...window.appRuntimeEnv,
            ...configJson,
        }
    } catch {
        throw new Error(
            'You must provide a config.json. If you are in local dev, put a config.json in your public folder'
        )
    }
}

const loadAppVersionsConfig = async () => {
    try {
        const appVersions = await fetch('/app_versions.json')
        const appVersionsJson = await appVersions.json()
        window.appRuntimeEnv = {
            ...window.appRuntimeEnv,
            ...appVersionsJson,
        }
    } catch {
        throw new Error(
            'You must provide a app_versions.json. If you are in local dev, put a app_versions.json in your public folder'
        )
    }
}

const retrieveApiConfig = async () => {
    try {
        const runtimeEnvSettings = JSON.parse(
            JSON.stringify(window.appRuntimeEnv)
        )
        const apiUrl = runtimeEnvSettings.APP_API_URL ?? process.env.APP_API_URL
        if (typeof apiUrl !== 'string') {
            return
        }

        const apiConfig = await fetch(apiUrl)
        const apiConfigJson = await apiConfig.json()
        const apiConfigObj = { APP_VERSIONAPI: apiConfigJson.version }
        window.appRuntimeEnv = {
            ...window.appRuntimeEnv,
            ...apiConfigObj,
        }
    } catch {
        //
    }
}

loadConfig()
    .then(() => loadAppVersionsConfig())
    .then(() => retrieveApiConfig())
    .then(() => {
        return import('./app.js')
    })
